module.exports = __webpack_public_path__ + "img/mowerwalk_parked.2d85b1f4.svg";